import { AvailableBenchmarksClient } from "../../../../../../../../Wrap/Api/PortfolioAnalysis/Benchmarks/AvailableBenchmarks";
import { ClientPortfolioReportClient } from "../../../../../../../../Wrap/Api/Reports/ClientPortfolio/ClientPortfolioReport";
import { UserSignatureClient } from "../../../../../../../../Wrap/Api/User/UserSignature";
import { ReportBuilder } from "../../../../../../../../Wrap/Models/Models/Reports/ReportBuilder";
import { ReportInfo } from "../../../../../../../../Wrap/Models/Models/Reports/ReportInfo";
import { ReportSetting } from "../../../../../../../../Wrap/Models/Models/Reports/ReportSetting";

export class ClientReportAction {
    public static setUserSignature(signature: string, hierarchyId: string, callback: (url) => void) {
        const client = new UserSignatureClient();
        const promise = client.post(signature, hierarchyId);
        promise.onSuccess((d) => {
            callback(d);
        });
    }

    public static getAvailableBenchmarks(callback: (result) => void) {
        const client = new AvailableBenchmarksClient();
        const promise = client.get();
        promise.onSuccess((d) => {
            callback(d);
        });
    }

    public static getUserSignature(hierarchyId: string, callback: (url) => void) {
        const client = new UserSignatureClient();
        const promise = client.get(hierarchyId);
        promise.onSuccess((d) => {
            callback(d);
        });
    }

    public static triggerReport(data: ReportBuilder, callback: (taskInfo: ReportInfo) => void) {
        const client = new ClientPortfolioReportClient();
        const promise = client.post(data);
        promise.onSuccess((d) => {
            callback(d);
        });
    }

    public static getReportSetting(callback: (reportSetting: ReportSetting) => void) {
        const client = new ClientPortfolioReportClient();
        const promise = client.get();
        promise.onSuccess((d) => {
            callback(d);
        });
    }
}
